import ActionTypes from './../common/ActionTypes';
import Strings from './../common/Strings';

function initialized(isInitialized) {
  return {
    type: ActionTypes.INITIALIZED,
    isInitialized,
  };
}

function showError(title, body) {
  return showDialog({
    image: '/emoji/weary.svg',
    title,
    body,
    buttonStyle: 'common-green-button',
    buttonText: Strings.COMMON.ok,
  });
}

function showSuccess(title, body) {
  return showDialog({
    title,
    body,
    buttonStyle: 'common-green-button',
    buttonText: Strings.COMMON.ok,
  });
}

function showDialog(dialog) {
  return {
    type: ActionTypes.SHOW_DIALOG,
    dialog,
  };
}

function closeDialog() {
  return {
    type: ActionTypes.SHOW_DIALOG,
    undefined,
  };
}

function updateAvailable(isUpdateAvailable) {
  return {
    type: ActionTypes.UPDATE_AVAILABLE,
    isUpdateAvailable,
  };
}

export const uiActions = {
  initialized,
  showError,
  showDialog,
  closeDialog,
  updateAvailable,
  showSuccess,
};



// WEBPACK FOOTER //
// ./src/actions/ui.js